import { render, staticRenderFns } from "./Map_one_point.vue?vue&type=template&id=8618f884"
import script from "./Map_one_point.vue?vue&type=script&lang=js"
export * from "./Map_one_point.vue?vue&type=script&lang=js"
import style0 from "./Map_one_point.vue?vue&type=style&index=0&id=8618f884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports